import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ParticleField from "@/components/ParticleField";
import { useProjects } from "@/lib/useProjects";

export default function Technology() {
  const { projects } = useProjects();
  const ecosystem = projects.filter((p) => !p.imjove_labs);

  return (
    <div>
      <SEO
        title="Technology & Companies — ImJove Tech"
        description="Explore every platform powered by ImJove Tech: NitePass, ChefPlated, Jove AI, SM Genie, Vyra, and more."
      />
      <section className="relative overflow-hidden pb-16 pt-40">
        <ParticleField className="absolute inset-0 z-0" density={35} />
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <p className="font-mono2 text-xs uppercase tracking-brand text-gold-light">The ImJove Ecosystem</p>
            <h1 className="mt-4 max-w-4xl font-display text-5xl font-bold tracking-tighter text-white sm:text-6xl">
              One company. <span className="text-silver-gradient">Multiple industries.</span>
            </h1>
            <p className="mt-6 max-w-2xl font-body text-lg text-white/55">
              Premium platforms across AI, nightlife, culinary, fintech, virtual worlds and more — each with its own identity, all powered by ImJove Tech.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {ecosystem.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.05}>
                <ProductCard project={p} />
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="mt-16 flex flex-col items-start gap-4 rounded-2xl border border-white/10 bg-ink-800 p-10 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="font-display text-2xl font-semibold text-white">Looking further ahead?</h3>
                <p className="mt-2 font-body text-white/55">Discover experimental technologies and future concepts inside ImJove Labs.</p>
              </div>
              <Link to="/labs" className="btn-gold inline-flex items-center gap-2 rounded-full px-6 py-3.5 font-mono2 text-[12px] font-semibold uppercase tracking-widest">
                Enter ImJove Labs <ArrowRight size={15} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
